import { jsxs as o, jsx as l } from "react/jsx-runtime";
const n = (e) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M14.2 7.4a1 1 0 0 1 1.4-.2 6 6 0 0 1 0 9.6 1 1 0 0 1-1.2-1.6 4 4 0 0 0 0-6.4 1 1 0 0 1-.2-1.4",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M16.923 4.371a1 1 0 0 1 1.406-.149 10.002 10.002 0 0 1 0 15.556 1 1 0 0 1-1.257-1.556 8 8 0 0 0 0-12.444 1 1 0 0 1-.15-1.407M10.78 3.159a1.8 1.8 0 0 0-2.115.786L5.511 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1.51l3.155 4.055A1.8 1.8 0 0 0 12 18.933V5.067a1.8 1.8 0 0 0-1.22-1.908",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  n as default
};
